import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, colors, RadioButton } from '@insurancemenu/imenu-components-lib';
import { useRootStore } from 'store/rootStore';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { toJS } from 'mobx';
import { createStyles } from './styles';

interface Props {
  portfolioId: string;
  productLineId: ProductLineId;
}

const CartItemSelectBar = observer(({ portfolioId, productLineId }: Props): JSX.Element => {
  // Mobx store
  const rootStore = useRootStore();
  const {
    proposalItemsStore: { setCartItemValue, getProductLineFromProposal, isProductLineDontProvide },
  } = rootStore;

  // Component actions
  function onChange(): void {
    setCartItemValue(productLineId, portfolioId, true);
  }

  function onUndo(): void {
    setCartItemValue(productLineId, portfolioId, false);
  }

  const productLine = toJS(getProductLineFromProposal(productLineId));
  const isButtonChecked = portfolioId === productLine.confirmedPortfolioId;

  const classes = createStyles();
  return (
    <div className={classes.actionBlock}>
      <RadioButton
        value={portfolioId}
        checked={isButtonChecked}
        label=""
        id={`select_${portfolioId}`}
        className={classes.radioButton}
        onChange={onChange}
      />
      {isButtonChecked ? (
        <Button color="primary" size="large" type="opaque">
          Plan Selected
        </Button>
      ) : (
        <Button color={isProductLineDontProvide(productLineId) ? 'default' : 'primary'} size="large" onClick={onChange}>
          Select this plan
        </Button>
      )}
      {isButtonChecked && (
        <Button onClick={onUndo} type="text" color="custom" customColor={colors.red[500]} className={classes.undoBtn}>
          UNDO
        </Button>
      )}
    </div>
  );
});

export default CartItemSelectBar;
